document.addEventListener('click', function (event) {
    var btnShowHide = event.target.closest('#btnShowTable, button[data-show="show"]');
    if (!btnShowHide) return;

    event.preventDefault();

    var scope = btnShowHide.closest('.infoNutrient-content') || document;
    var content = scope.querySelector('div[data-show="content"]');
    if (!content) return;

    if (btnShowHide.getAttribute('aria-expanded') === 'true') {
        btnShowHide.setAttribute('aria-expanded', 'false');
        $(content).slideUp('slow');
        btnShowHide.innerText = 'VER MÁS';
    } else {
        btnShowHide.setAttribute('aria-expanded', 'true');
        $(content).slideDown('slow');
        btnShowHide.innerText = 'VER MENOS';
    }
});

function showTable() {}